export default "__VITE_ASSET__DsEL5JXK__"